window.AppointmentBooking ??= {};
window.AppointmentBooking.Wizard ??= {};
window.AppointmentBooking.Wizard.Views ??= {};
window.AppointmentBooking.Wizard.Views.Mixins ??= {};

AppointmentBooking.Wizard.Views.Mixins.AppointmentSlotPicker = (superclass) =>
  (() => {
    const Cls = class extends superclass {
      constructor() {
        super(...arguments);
        this.handleAppointmentSlotPickerClick = this.handleAppointmentSlotPickerClick.bind(this);
        this.handleValidatedAppointmentSlotPicker = this.handleValidatedAppointmentSlotPicker.bind(this);
        this.handleSlotClick = this.handleSlotClick.bind(this);
        this.triggerSlotAction = this.triggerSlotAction.bind(this);
        this.handleSlotPick = this.handleSlotPick.bind(this);
        this.showAppointmentSelectorPicker = this.showAppointmentSelectorPicker.bind(this);
        this.showValidatedAppointmentSelectorPicker = this.showValidatedAppointmentSelectorPicker.bind(this);
        this.getSlotDate = this.getSlotDate.bind(this);
        this.selectSlot = this.selectSlot.bind(this);
        this.showAppointmentSelector = this.showAppointmentSelector.bind(this);
      }

      // EVENT HANDLERS

      handleAppointmentSlotPickerClick() {
        return this.showAppointmentSelectorPicker();
      }

      handleValidatedAppointmentSlotPicker() {
        return this.showValidatedAppointmentSelectorPicker();
      }

      handleSlotClick(e) {
        return this.triggerSlotAction(e);
      }

      triggerSlotAction(e) {
        const slotId = jQuery(e.target).data("slot-id");
        return this.selectSlot(slotId);
      }

      // Handle clicks on slot picker slots
      handleSlotPick(slot) {
        this.selectSlot(slot.id);
        return this.slotPickerModal.hide();
      }

      // HELPERS
      showAppointmentSelectorPicker() {
        return this.showAppointmentSelector(
          this.model.get("provider"),
          this.model.get("address"),
          this.model.get("visit_type_id"),
          this.getSlotDate(),
          this.model.get("returning_patient"),
        );
      }

      showValidatedAppointmentSelectorPicker() {
        return this.showAppointmentSelector(
          this.model.get("validated_provider"),
          this.model.get("validated_address"),
          this.model.get("validated_visit_type_id"),
          this.getSlotDate("validated_"),
          this.model.get("validated_returning_patient"),
        );
      }

      getSlotDate(prefix) {
        let slot_date;
        if (prefix == null) {
          prefix = "";
        }
        const visit_type_id = this.model.get(`${prefix}visit_type_id`);
        const visit_slots = this.model
          .get(`${prefix}visit_types`)
          .find((visit_type) => visit_type.id === visit_type_id);

        if (visit_slots?.suggested_slots?.[0]?.start_time) {
          slot_date = visit_slots.suggested_slots[0].start_time;
        } else {
          slot_date = this.model.get(`${prefix}appointment_slot`).start_time;
        }

        return slot_date;
      }

      selectSlot(slotId) {
        this.model.set("ehr_appointment_slot_id", slotId);
        return this.scrollTo(this.el);
      }

      showAppointmentSelector(provider, address, visitTypeId, focusDate, returningPatient) {
        const filters = {
          address_id: address.id, // From the address we can infer the resource
          patient_type: returningPatient ? "returning" : "new",
          visit_types: visitTypeId,
        };

        const options = {
          renderLinks: false, // we handle slot picking via AJAX
          availabilitySelector: false,
          patientTypeSelector: false,
          addressSelector: false,
          analyticsScope: "booking",
          onSlotPick: (slot) => this.handleSlotPick(slot), // We must wrap this ourselves because this method comes from a "mixin" and isn't bound to this instance
        };

        return AppointmentBooking.showSlotPickerModal({ focusDate, filters, options }).then(
          (slotPickerModal) => (this.slotPickerModal = slotPickerModal),
        );
      }
    };
    Cls.prototype.events = {
      'click [data-appointment-booking-wizard-behaviour="show-appointment-slot-picker"]':
        "handleAppointmentSlotPickerClick",
      'click [data-appointment-booking-wizard-behaviour="show-validated-appointment-slot-picker"]':
        "handleValidatedAppointmentSlotPicker",
      "click [data-slot-id]": "handleSlotClick",
    };
    return Cls;
  })();
